module.exports = __webpack_public_path__ + "img/separator16.75dc7597.svg";